<template>
  <main class="mb-3">
    <!--    banner-->
    <div class="w-100  banner-scroll-box slide" :class="{'carousel':!loading}" id="carouselExampleIndicators" data-bs-ride="carousel" data-bs-interval="1500">
      <div class="carousel-indicators">
        <button type="button" v-for="(b,index) of banner" :key="index"
                data-bs-target="#carouselExampleIndicators"
                :data-bs-slide-to="index"
                class="active" aria-current="true"
                aria-label="Slide 1"></button>
      </div>

      <div class="carousel-inner h-100" >
        <a class="carousel-item active h-100" v-for="b of banner" :key="b" href="https://bsc.mnmcloud.com" target="_blank">
          <img :src="b.Image" class="d-block w-100 bg-img" alt="点击报名">
        </a>
      </div>
      <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="prev">
        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
        <span class="visually-hidden">上一页</span>
      </button>
      <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="next">
        <span class="carousel-control-next-icon" aria-hidden="true"></span>
        <span class="visually-hidden">下一页</span>
      </button>
    </div>
    <!--    消息通知-->
    <div class="bg-white shadow-sm" >
      <div class="container-lg d-flex align-items-center justify-content-between py-2 py-sm-2 max-width-1200">
        <div class="flex-shrink-0 d-flex align-items-center">
          <img src="../../assets/images/info.png" alt="" class="info-icon flex-shrink-0 me-2">
          <text class="fw-bold text-primary  me-2 me-sm-3 flex-shrink-0 d-none d-sm-block">通知公告</text>
        </div>
        <div class="message-middel">
          <infoTipsBox :messages="notice" :path="'/comNoticeDetail'"></infoTipsBox>
        </div>
        <span class="text-primary px-2 point-curser fw-bold flex-shrink-0" @click="more">更多</span>
      </div>
    </div>
<!--    内容-->
    <div class="container-lg my-3 max-width-1200">
      <div :class="{'placeholder':loading}" v-if="loading" style="width: 100%;height: 300px" class="d-flex align-items-center justify-content-center">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
      <div class="bg-white p-3 rounded-3 shadow-sm" v-if="!loading">
        <div class="h5  fw-bold pub-one-row-flex pe-2 lh-lg text-center border-bottom">
          {{intro.Title}}
        </div>
        <div class="content py-3">
          <div v-html="intro.Content" class="pub-html-style">
          </div>
        </div>
        <div class="px-2 py-2 text-primary mt-3 fw-bold" v-if="Files && Files.length>0">
          附件下载
        </div>
        <p class="py-2 px-2" v-for="(item,index) of Files" :key="index">
          <a target="_blank"  :href="item.url" :download="item.name" title="下载" class="link-underline-primary pub-hover-primary">{{item.name}}</a>
        </p>
        <div class="d-flex align-items-center justify-content-center p-4">
          <a href="https://bsc.mnmcloud.com" target="_blank" type="button" class="btn btn-primary px-5" >立即报名</a>
        </div>
      </div>
    </div>
  </main>

</template>

<script setup>
import {computed, onMounted, onUnmounted, ref} from "vue";
import infoTipsBox from "@/components/infoTipsBox"
import {useStore} from 'vuex'
import {showToast} from "@/utils/toast";
import router from "@/router";
import {bgtop} from "@/utils/commonSetting";
const store = useStore()
const banner = ref([{
  Image:bgtop
}])
// const banner = ref([])
const Files = ref([]) // 资料
const loading = ref(true)
const notice = computed(()=> store.state.competitionModel.notice)//通知公告
const intro = computed(()=> store.state.competitionModel.intro)//介绍
onUnmounted(()=>{

})
onMounted(async ()=>{
  loading.value = true
  await store.dispatch("competitionModel/getCompetitionHomeInfoAction") //获取大赛信息
  const bList = store.getters["competitionModel/getBanner"]
  if(bList.length>0){
    banner.value = bList
  }
  const bIntro = store.getters["competitionModel/getIntro"]
  if(bIntro.Files){
    const arr = bIntro.Files.split(";")
    const fi = []
    arr.forEach(item=>{
      fi.push({
        name:item.match(/[^/]+$/)[0],
        url:item
      })
    })
    Files.value =fi
  }else{
    Files.value = []
  }

  loading.value = false
})

const apply = ()=>{
  showToast("message","暂未开放")
}

const more = ()=>{
  router.push({path:'/comNotice'})
}


</script>

<style scoped lang="scss">
.bg-top {
  position: relative;
}
.mt-n3{
  margin-top: -4rem !important;
}
.drop-link--Active{
  //font-weight: bold;
  background: rgb(242, 246, 253);
  position: relative;
  &:after{
    content: "";
    width:4px;
    background:#0d6efd;
    height: 100%;
    left: 0;
    top: 0;
    position:absolute;
  }
}
.top-rounded{
  border-radius:0.5rem 0.5rem 0 0;
}
.bottom-rounded{
  border-radius:0 0 0.5rem 0.5rem;
}
.list-group-item:hover{
  background: rgb(242, 246, 253);
}
.message-middel{
  width: calc(100% - 60px);
}
</style>
